import { PreloadedQuery } from 'react-relay';

import { createRelayResource } from '@townsquare/relay-utils';
import { getAggRelayEnvironment } from '@townsquare/relay-utils/agg-environment';
import { RouteResource } from '@townsquare/router/routing-types';
import type { ResourceContext } from '@townsquare/router/types';
import { fg } from '@townsquare/stat-sig/gate';

import ThreadsV2_Query, {
	type ThreadsV2_Query as ThreadsV2_QueryType,
} from '../components/__generated__/ThreadsV2_Query.graphql';

export const v2Resource: RouteResource<
	PreloadedQuery<ThreadsV2_QueryType, Record<string, unknown>>
> = createRelayResource<ThreadsV2_QueryType>({
	getQuery: (_routerContext, resourceStoreContext) => {
		const context = resourceStoreContext as ResourceContext;

		const isEnabled = !!(
			fg('townsquare_enable_threads') &&
			context.collabContext?.rovoWorkspace &&
			context.user.accountId
		);

		return {
			environment: getAggRelayEnvironment(),
			query: ThreadsV2_Query,
			variables: {
				cloudId: context.collabContext?.rovoWorkspace ?? '',
				experience: 'home-threads',
				isEnabled: isEnabled,
			},
		};
	},
});
